<template>
  <div class="sign-in-user-exist">
    <DefTitle :result="3">
      <h2>
        {{ message }}
      </h2>
    </DefTitle>

    <EnterCabinet :update-phone="phone" />

    <DefLink class="sign-in-user-exist__mistake" @click="handlerMistake">
      {{ messages.wrongNumber }}
    </DefLink>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import EnterCabinet from '@components/Cabinet/EnterCabinet/EnterCabinet.vue';
import DefLink from '@components/Def/DefLink/DefLink.vue';
import useModal from '@use/useModal/useModal';
import SignInUpdate from '@components/Cabinet/Entry/SignInPhoneUpdate/SignInUpdate.vue';

export default {
  name: 'SignInUserExist',
  components: { DefLink, EnterCabinet, DefTitle },
  props: ['message', 'phone'],
  data() {
    return {
      modal: useModal(),
    };
  },

  mounted() {
    this.changeActiveTab('enter');
    this.setEnter('phone');
    this.clearState();
    // this.$store.commit('personal/setError', this.message);
    // this.openModalEnter();
  },
  computed: {
    ...mapState({
      user: ({ personal }) => personal.data?.authInfo,
      messages: ({ results }) => results.messages.entry,
      errorConfirmPhone: ({ personal }) => personal.data?.errors?.confirmPhone,
    }),
  },
  methods: {
    ...mapMutations({
      changeActiveTab: 'personal/changeActiveTab',
      setEnter: 'personal/setEnter',
      clearState: 'personal/clearState',
      setError: 'personal/setError',
    }),
    handlerMistake() {
      this.modal.show(
        SignInUpdate,
        {
          response: {
            id: this.user.user_id,
            phone: this.user.userPersonalPhone,
          },
        },
        {
          width: '340px',
        }
      );
      // this.$DefModal.show({
      //   name: 'SignInUpdate',
      //   width: '340px',
      //   backgroundClose: () => {
      //     this.setError({ closeModalError: this.messages.closeModalError });
      //   },
      //   isShowClose: false,
      //   props: {
      //     response: {
      //       id: this.user.user_id,
      //       phone: this.user.userPersonalPhone,
      //     },
      //   },
      // });
    },
    // openModalEnter() {
    //     this.$DefModal.show({
    //         name: 'enter-cabinet',
    //         width: '440px',
    //         props: {
    //             updatePhone: this.phone,
    //         },
    //     });
    // },
  },
  // beforeUnmount() {
  //    location.reload();
  // }
};
</script>

<style lang="scss" scoped>
.sign-in-user-exist {
  &__mistake {
    margin-bottom: 24px;
  }
  :deep(.def-title h2) {
    color: grey;
    font-size: rem(12);
  }
}
</style>
